import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { setScorecardFormInitialValue as loadAccount, setcorporateModal } from '../action';
import { Button } from 'reactstrap';
import StringConst from '../../../StringConst';
import './style.css'
import CreateScorecardModal from '../CreateScorecardModal/index'

class ScorecardForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scorecardName: '',
            corporateName: '',
            counterPartyType: '',
            counterPartyTypeDropdown: null
        }
    }
    componentDidUpdate(previousProps) {
        if (this.props.scorecardEditData) {
            if (previousProps.scorecardEditData !== this.props.scorecardEditData) {
                this.props.load(this.props.scorecardEditData);
                this.setState({
                    scorecardName: this.props.scorecardEditData.scorecardName,
                    corporateName: this.props.scorecardEditData.corporateName,
                    counterPartyType: this.props.scorecardEditData.counterPartyType
                })
            }
        }
        if (this.props.counterPartyTypeDropdown !== previousProps.counterPartyTypeDropdown) {
            this.setState({
                counterPartyTypeDropdown: this.props.counterPartyTypeDropdown.map(p => {
                    return (<option key={p} value={p}>{p}</option>)
                })
            })
        }
    }
    componentWillUnmount() {
        this.props.load({});
    }
    handleFormChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }
    handleCorporateSearchClick = (e) => {
        /* this.setState({
            option: StringConst.CorporateLabel
        }) */
        this.props.setcorporateModal();
    }
    handleSelectedCorporate = (param) => {
        this.props.change('corporateName', param.corporateName)
    }
    render() {
        return (
            <form className="w-70" onChange={(event) => this.handleFormChange(event)} autoComplete="on">
                <Field name="scorecardName" type="text"
                    className="form-control"
                    component={renderField}
                    validate={[required]}
                    label="Scorecard Name"
                />

                <div className="form-group mb-4">
                    <label>Corporate Name&nbsp;<span className="text-danger">*</span></label>
                    <div className="row">
                        <div className="col-22">
                            <Field
                                name="corporateName"
                                className="form-control"
                                type="text"
                                validate={[required]}
                                component="input"
                                readOnly
                            />
                        </div>
                        <div className="col-2 pl-0">
                            <Button className="pl-0" type="button" color="link" value={StringConst.CorporateLabel} onClick={this.handleCorporateSearchClick}>
                                <i className="icon-search"></i>
                            </Button>
                        </div>
                    </div>
                </div>

                <div className="form-group mb-4">
                    <label>Counterparty Type&nbsp;<span className="text-danger">*</span></label>
                    <div className="col pl-0">
                        <Field name="counterPartyType" className="form-control" component="select">
                            <option value=''>Select</option>
                            {this.state.counterPartyTypeDropdown}
                        </Field>
                    </div>
                </div>
                <CreateScorecardModal onSelectCounterparty={(param) => this.handleSelectedCorporate(param)} />
            </form>
        )
    }
}
const renderField = ({ className, input, label, type,
    meta: { touched, error, warning } }) => {
    return (
        <div className="form-group mb-4">
            <label>{label}&nbsp;<span className="text-danger">*</span></label>
            <div className="col pl-0">
                <input {...input} placeholder={label} type={type} className={className} required />
                {touched && ((error && <span className="error">{error}</span>) || (warning && <span>{warning}</span>))}
            </div>
        </div>
    )
}
const required = value => value ? undefined : 'Required';
ScorecardForm = reduxForm({
    form: 'scoreform',
    enableReinitialize: true
})(ScorecardForm)

ScorecardForm = connect(
    //  mapDispatchToProps,
    state => ({
        initialValues: state.scorecardInitialValues.data,
        corporateModal: state.createScorecard.corporateModal,
        counterPartyTypeDropdown: state.createCase.dropdownData // pull initial values from account reducer
    }),
    ({
        load: loadAccount,
        setcorporateModal: () => setcorporateModal()
    }),

)(ScorecardForm)

export default ScorecardForm
